import { render } from "./MaintenancePage.vue?vue&type=template&id=60ea2dc8&scoped=true"
import script from "./MaintenancePage.vue?vue&type=script&lang=js"
export * from "./MaintenancePage.vue?vue&type=script&lang=js"

import "./MaintenancePage.vue?vue&type=style&index=0&id=60ea2dc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ea2dc8"]])

export default __exports__